@if (+data?.status === 1) {
  <div
    class="d-flex gap-1"
    (click)="$event.stopPropagation()"
  >
    <ncp-button #delBtn [options]="deleteBtnOptions()" />
    <ncp-button #printBtn [options]="printBtnOptions()" />
    <ncp-button #cdaBtn [options]="cdaBtnOptions()" />

    <!-- Delete modal -->
    <ncp-modal
      #deleteMod
      [options]="deleteModOptions()"
    />

    <!-- PDF / CDA preview modal -->
    <ncp-modal
      #previewMod
      [options]="previewModOptions()"
    >
      <div class="d-flex flex-grow-1">
        @if (previewType() === 'application/pdf' && previewUrl()) {
          <div class="d-flex flex-grow-1">
            <embed
              [src]="previewUrl()"
              type="application/pdf"
              class="flex-grow-1"
            />
          </div>
        }

        @if (previewType() === 'text/html' && previewUrl()) {
          <div class="d-flex flex-grow-1">
            <iframe
              [src]="previewUrl()"
              class="flex-grow-1"
              style="border: var(--border-2) var(--border-solid) var(--border-primary-blue); border-radius: 4px;"
            ></iframe>
          </div>
        }
      </div>
    </ncp-modal>
  </div>
}
